import React, {Component} from 'react';
import MatchWhenLoggedIn from './../MatchWhenLoggedIn';
import {Route, Redirect, Switch} from 'react-router-dom';
import DocumentiList from './DocumentiList'


class DocumentiContent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (<div>
            <Switch>
            <Route exact path='/app/documenti' render={() => (
                <Redirect
                    to='/app/documenti/list'
                />
            )} />
            <MatchWhenLoggedIn path='/app/documenti/list' component={DocumentiList} />
            </Switch>
        </div>)
    }
}

export default DocumentiContent;




/** WEBPACK FOOTER **
 ** ./src/components/documenti/DocumentiContent.js
 **/